const sleep = (retryCount) => {
  const initialDelay = 3000; // 3 seconds
  const backoffDelay = 30000; // 30 seconds

  let delay = initialDelay;

  if (retryCount >= 3) {
    delay = backoffDelay;
  }

  return new Promise(resolve => setTimeout(resolve, delay));
};

export { sleep };